import { render } from "./DynamicComponentBuilder.vue?vue&type=template&id=4f07bd29&ts=true"
import script from "./DynamicComponentBuilder.vue?vue&type=script&lang=ts"
export * from "./DynamicComponentBuilder.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/DynamicComponentBuilder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f07bd29"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f07bd29', __exports__)) {
    api.reload('4f07bd29', __exports__)
  }
  
  module.hot.accept("./DynamicComponentBuilder.vue?vue&type=template&id=4f07bd29&ts=true", () => {
    api.rerender('4f07bd29', render)
  })

}


export default __exports__